<template>
    <BaseTableItemAction
      v-can:[showPermission]
      v-on="$listeners"
      v-bind="$attrs"
      icon="mdi-eye"
      actionName="عرض التفاصيل"
      :to="'/admins/' + item.id"
    >
      <slot></slot>
    </BaseTableItemAction>
  </template>
  
  <script>
  import { READ_ADMINS_PERMISSION } from "@/core/statics/Permissions";
  
  export default {
    props: {
      item: Object,
    },
    data() {
      return {
        showPermission: READ_ADMINS_PERMISSION,
      };
    },
  };
  </script>
  